import Labrant from '../../pages/labrant/Labrant'

import PrefixEnum from '../prefixes'

export default Object.freeze([{ path: PrefixEnum.LABRANT, component: Labrant }])
